export default "__VITE_ASSET__Bbm9Uue0__ 400w, __VITE_ASSET__CAm1ZRzm__ 800w, __VITE_ASSET__DvdQ2nkm__ 1200w";